import qs from 'qs';
import { createAction } from '@reduxjs/toolkit';
import { takeLatest, put } from 'redux-saga/effects';

import http from 'app/services/httpService';
import apiEndpoints from 'routes/apiEndpoints';
import { callWrapperSaga } from 'app/services/sagaService';

import {
  getFlashPaymentWebhookLogsInit,
  getFlashPaymentWebhookLogsSuccess,
  getFlashPaymentWebhookLogsFailure,
} from './flashPaymentWebhookLogSlice';

const getFlashPaymentWebhookLogs = createAction('flashPaymentWebhookLogs/list');

function* getFlashPaymentWebhookLogsSaga({ payload }) {
  yield put(getFlashPaymentWebhookLogsInit());
  try {
    const { page_number, page_size, ...rest } = payload || {};
    const query = {
      ...rest,
      PageNumber: page_number,
      PageSize: page_size,
    };
    const endpoint = `${apiEndpoints.getFlashPaymentWebhookLogs}?${qs.stringify(query)}`;
    const response = yield callWrapperSaga(() => http.get(endpoint));
    yield put(getFlashPaymentWebhookLogsSuccess(response.data));
  } catch (error) {
    yield put(getFlashPaymentWebhookLogsFailure(error));
  }
}

function* flashPaymentWebhookLogSaga() {
  yield takeLatest(getFlashPaymentWebhookLogs, getFlashPaymentWebhookLogsSaga);
}

export default flashPaymentWebhookLogSaga;

export { getFlashPaymentWebhookLogs };
